import styled, { css } from 'styled-components';
import { CardContentProps } from '../types/styles';
import { DANGER_COLOR, SECONDARY_BG_COLOR } from 'shared/consts';

export const GuestCardContainer = styled.div`
	overflow-y: auto;
	height: calc(100dvh - 164px);
`;

export const CardContent = styled.div<CardContentProps>`
	padding: 4px 8px;
	${props =>
		props.$paddingBottom &&
		css`
			padding-bottom: 0;
		`}
	color: black;
	cursor: pointer;
`;

export const CardContainer = styled.div<{ $withBorder?: boolean, $borderRadius?: string }>`
	margin-bottom: 2px;
	border: 4px solid white;

  ${props => props.$borderRadius && css`
    border-radius: ${props.$borderRadius};
  `}

	${props => props.$withBorder && css`
    border-color: ${DANGER_COLOR};
  `}

  &:has(+.guests-time),
  &:has(+.guests-title) {
	  margin-bottom: 12px;
  }

  @media (any-hover: hover){
    &:hover {
      .confirm-order {
        opacity: 1;
        visibility: visible;
      }
    }
  }
`;

export const CardInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const Title = styled.div`
	color: #000000;
	font-weight: 600;
	font-size: 18px;
	margin: 0;
	line-height: 21.6px;
	padding-bottom: 4px;
	max-width: calc(100% - 40px);

	@media only screen and (min-device-width: 768px) and (max-device-width: 768px) {
		max-width: 180px;
	}

	@media only screen and (min-device-width: 820px) and (max-device-width: 820px) {
		max-width: 180px;
	}
`;

export const TimeContent = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	color: #666666;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
`;

export const TimeText = styled.div`
	font-size: 14px;
	color: #060913;
	font-weight: 400;
	line-height: 19.2px;
	margin-right: 4px;
`;

export const Icon = styled.div`
	position: relative;
	top: 1px;
`;

export const DepositWrapper = styled.div`
  display: flex;
  justify-content:center;align-items: center;
  aspect-ratio: 1;
  flex: 0 0 20px;
  width: 20px;
  border-radius: 4px;
  background-color: ${SECONDARY_BG_COLOR};

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    object-position: center;
  }
`
